import React from 'react';
import PropTypes from "prop-types";
import {startOfDay} from "date-fns";

import {isValidDateObject} from "../../../services/date/validators";
import {bookingItemOption} from "./utils";

import {DatePicker} from "@mui/x-date-pickers";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {Checkbox} from "@mui/material";
import Typography from "@mui/material/Typography";


const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
const checkedIcon = <CheckBoxIcon fontSize="small"/>;

const StepBooking = props => {
    const {formik, booking, accommodations, handleArrivalChange, handleBookingItemsChange} = props;

    const options = [
        ...booking.bookingItems.map((bi) => bookingItemOption(
            accommodations.findAccommodationUnit(bi.bookableType, bi.bookableId),
            bi.price ? bi.price : null)),
        ...accommodations.accommodationUnits
            .filter(a => !booking.bookingItems.find(bi => a.type === bi.bookableType && a.id === bi.bookableId))
            .map((a) => bookingItemOption(a, null))
    ]

    return (
        <>
            <Typography variant='h6' color='primary' fontWeight="normal" sx={{mb: 2}}>
                Dettagli prenotazione
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Autocomplete
                        multiple
                        value={formik.values.bookingItems}
                        options={options}
                        groupBy={(option) => option.accommodation.name}
                        isOptionEqualToValue={(o, v) => o.id === v.id && o.type === v.type}
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option, {selected}) => (
                            <li {...props}>
                                <Checkbox icon={icon}
                                          checkedIcon={checkedIcon}
                                          style={{marginRight: 8}}
                                          checked={selected}/>
                                {option.name}
                            </li>
                        )}
                        onChange={(event, value) => {
                            const selectedItems = value.sort(
                                (a, b) => a.accommodation.name.localeCompare(b.accommodation.name) || a.name.localeCompare(b.name)
                            );
                            handleBookingItemsChange(selectedItems);
                        }}
                        renderInput={(params) => (
                            <TextField {...params}
                                       label="Strutture prenotate"
                                       fullWidth
                                       required
                                       error={formik.touched.bookingItems && Boolean(formik.errors.bookingItems)}
                                       helperText={formik.touched.bookingItems && formik.errors.bookingItems}/>
                        )}/>
                </Grid>

                <Grid item xs={12} md={6}>
                    <DatePicker value={formik.values.arrival}
                                onChange={handleArrivalChange}
                                disablePast
                                label="Data arrivo"
                                closeOnSelect
                                disableHighlightToday
                                showDaysOutsideCurrentMonth
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        required: true,
                                        error: Boolean(formik.touched.arrival) && Boolean(formik.errors.arrival),
                                        helperText: formik.touched.arrival && formik.errors.arrival
                                    }
                                }}
                                />
                </Grid>

                <Grid item xs={12} md={6}>
                        <DatePicker value={formik.values.departure}
                                    onChange={date => formik.setFieldValue("departure", startOfDay(date))}
                                    disablePast
                                    minDate={formik.values.arrival}
                                    defaultCalendarMonth={isValidDateObject(formik.values.arrival) ? formik.values.arrival : undefined}
                                    label="Data partenza"
                                    closeOnSelect
                                    disableHighlightToday
                                    showDaysOutsideCurrentMonth
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            required: true,
                                            error: Boolean(formik.touched.departure) && Boolean(formik.errors.departure),
                                            helperText: formik.touched.departure && formik.errors.departure
                                        }
                                    }}
                                    />
                </Grid>

                <Grid item xs={12} sx={{mt: 2}}>
                    <TextField type="number"
                               label="Numero adulti"
                               fullWidth
                               name="adults"
                               required
                               value={formik.values.adults}
                               onChange={formik.handleChange}
                               error={formik.touched.adults && Boolean(formik.errors.adults)}
                               helperText={formik.touched.adults && formik.errors.adults}/>
                </Grid>

                <Grid item xs={12}>
                    <TextField type="number"
                               label="Numero bambini"
                               fullWidth
                               name="children"
                               required
                               value={formik.values.children}
                               onChange={formik.handleChange}
                               error={formik.touched.children && Boolean(formik.errors.children)}
                               helperText={formik.touched.children && formik.errors.children}/>
                </Grid>

                <Grid item xs={12}>
                    <TextField type="number"
                               label="Numero animali domestici"
                               fullWidth
                               name="petsNumber"
                               required
                               value={formik.values.petsNumber}
                               onChange={formik.handleChange}
                               error={formik.touched.petsNumber && Boolean(formik.errors.petsNumber)}
                               helperText={formik.touched.petsNumber && formik.errors.petsNumber}/>
                </Grid>
            </Grid>
        </>
    );
};

StepBooking.propTypes = {
    formik: PropTypes.object.isRequired,
    accommodations: PropTypes.object.isRequired,
};

export default StepBooking;